// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","cancel":"Button_cancel__MOD8z","next":"Button_next__Ig97Y","custom":"Button_custom__5Nnsw","disabled":"Button_disabled__DkgJ+"};